module.exports = __webpack_public_path__ + "img/symbol_3.c62efe21.png";